import React, { useState } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import axios from 'axios';
import logoLight from './../Images/tsqs-hm-ft-logo1.gif';
import logoDark from './../Images/tsqs-hm-ft-logo.gif';
import { useToast } from './ToastContext';
import './../Styles/Login.css';

const apiUrl = process.env.REACT_APP_API_URL;

const ResetPassword = () => {
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token');
  const navigate = useNavigate();
  const showToast = useToast();

  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!newPassword || !confirmPassword) {
      showToast('Please fill in both fields.', 'error');
      return;
    }
    if (newPassword !== confirmPassword) {
      showToast('Passwords do not match.', 'error');
      return;
    }
    if (newPassword.length < 4) {
      showToast('Password must be at least 4 characters.', 'error');
      return;
    }
    if (!token) {
      showToast('Invalid or missing reset token.', 'error');
      return;
    }

    setLoading(true);
    try {
      const response = await axios.post(`${apiUrl}/api/reset-password`, { token, newPassword });
      showToast(response.data.message || 'Password reset successfully!', 'success');
      setTimeout(() => navigate('/'), 2000);
    } catch (error) {
      const msg = error.response?.data?.error || 'Failed to reset password. The link may have expired.';
      showToast(msg, 'error');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-page">
      <div className="header">
        <div className="logo-container">
          <>
            <img src={logoLight} alt="Company Logo" className="logo logo-light" />
            <img src={logoDark} alt="Company Logo" className="logo logo-dark" />
          </>
        </div>
        <h1 className="main-heading" style={{ fontSize: '3rem', fontWeight: 'bold' }}>Tconnect</h1>
      </div>
      <div className="login-container">
        <div className="login-card">
          <h2>Reset Password</h2>
          {!token ? (
            <p style={{ color: 'red', textAlign: 'center' }}>
              Invalid reset link. Please request a new one from the login page.
            </p>
          ) : (
            <form onSubmit={handleSubmit} className="login-form">
              <div className="pms-form-group">
                <label className="pms-label">
                  New Password: <span className="required-asterisk">*</span>
                </label>
                <input
                  className="pms-input"
                  type="password"
                  value={newPassword}
                  onChange={(e) => setNewPassword(e.target.value)}
                  placeholder="Enter new password"
                />
              </div>
              <div className="pms-form-group">
                <label className="pms-label">
                  Confirm Password: <span className="required-asterisk">*</span>
                </label>
                <input
                  className="pms-input"
                  type="password"
                  value={confirmPassword}
                  onChange={(e) => setConfirmPassword(e.target.value)}
                  placeholder="Confirm new password"
                />
              </div>
              <button
                type="submit"
                className="pms-btn pms-btn-primary login-btn-full"
                disabled={loading}
              >
                {loading ? 'Resetting...' : 'Reset Password'}
              </button>
            </form>
          )}
          <p className="login-footer-text" style={{ textAlign: 'center', marginTop: '16px' }}>
            <span
              onClick={() => navigate('/')}
              style={{ cursor: 'pointer', color: 'var(--brand)', fontWeight: 'bold' }}
            >
              Back to Login
            </span>
          </p>
        </div>
      </div>
    </div>
  );
};

export default ResetPassword;
